export { default } from '@shikijs/langs/latex'
